import useStatusList from "../utils/useStatusList";
import useCategory from "../utils/useCategory";
import { Typography } from "@mui/material";
import useCart from "../utils/useCart";

export default function Status(){

    const category = useCategory();

    const statusList = useStatusList();

    const { cart, setCart } = useCart();

    const handleClick = status => {
        setCart({ category: category.id, status: status.id, product: null, session: null });
    }

    return statusList.length > 0 && <>

        <Typography variant="h5" align="center">Votre statut professionnel :</Typography>

        <div className="apply-choices">

            {statusList.map(opt => 
                <div
                    key={opt.id}
                    className="apply-choice" 
                    onClick={() => handleClick(opt)}
                    style={opt.id === cart.status ? {
                        backgroundColor: category?.color,
                        borderColor: category?.color,
                        color: 'white'
                    } : null}
                >
                    <span>{opt.title}</span>
                </div>    
            )}

        </div>
    
    </>
}